<template>
  <div class="main">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">申请</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>

    <div v-if="play_info.state_check==''">

    <div class="top ub ub-ver">
        <span class="sp1 ub ub-ac ub-pc">新店员申请资料</span>
        <span class="sp2">“小火柴聊天”期待你的记入！请认真填写资料，审核人员在3天内添加你的微信。请耐心等候！</span>
    </div>

    <div class="info2">
        <div class="info-photo ub ub-ac">
           <img :src="info.photo" class="photo" />
        </div>

        <div class="info-item ub ub-pc">
            <span class="key">昵称</span>
            <div><input readonly="readonly" type="text" v-model="info.nick" placeholder="请输入昵称" class="input-verify"></div>
        </div>

        <div class="info-item ub ub-pc">
            <span class="key">性别</span>
            <div><input readonly="readonly" type="text" v-model="info.sex" placeholder="请输入性别" class="input-verify"></div>
        </div>

         <div class="info-item ub ub-pc">
            <span class="key">年龄</span>
            <div><input readonly="readonly" type="text" v-model="info.age_range" placeholder="请输入年龄" class="input-verify"></div>
        </div>

         <div class="info-item ub ub-pc">
            <span class="key">微信</span>
            <div><input readonly="readonly" type="text" v-model="info.wx" placeholder="请前往个人中心完善" class="input-verify"></div>
        </div>

         <div class="info-item ub ub-pc">
            <span class="key">手机号</span>
            <div><input readonly="readonly" type="text" v-model="info.tel" placeholder="请前往个人中心完善" class="input-verify"></div>
        </div>

         <div class="info-item ub ub-pc">
            <span class="key">所在城市</span>
            <div style="display: inline-block;">
              <input readonly="readonly" type="text" v-model="info.loc" placeholder="请前往个人中心完善" class="input-verify">
              </div>
        </div>

         <div class="info-item ub ub-pc">
            <span class="key">相关经验</span>
            <div><input type="text" v-model="info.exper" placeholder="是否有其他店铺的经验" class="input-verify"></div>
        </div>

       
    </div>
    <div class="ub ub-ac btn-block">
      <div class="ub ub-ac ub-pc submit-btn" @click="seve()" >下一步</div>
    </div>

</div>

<div v-if="play_info.state_check=='通过'||play_info.state_check=='失败'">

      <div @click="goto_play_dtl(play_info.uid)">
    <div class="infoma ub">
      <div class="photo-black">
        <img :src="play_info.photo" class="photo" />
        <span class="photo-tag ub ub-pc ub-ac">{{play_info.play_level}}</span>
      </div>
      <div class="ub ub-ver ub-f1">
        <div class="ub">
          <div class="ub ub-pc">
            <span class="nick2">{{play_info.nick}}</span>
            <img v-if="play_info.sex=='女生'" src="../../assets/img/女.png" class="sex-img" />
            <img v-if="play_info.sex=='男生'" src="../../assets/img/男.png" class="sex-img" />
          </div>
          <div class="ub ub-f1 ub-ae">
            <div class="tip ub ub-pc"  v-for="(s, index) in play_info.serve" :key="index">
              <div class="d1"></div>
              <span class="sp2">{{s}}</span>
            </div>
          </div>
        </div>

        <div>
          <span class="tag" v-for="(t, index) in play_info.tags" :key="index">{{t}}</span>
        </div>
        <div>
          <div class="voice ub ub-pc">
           <img src="../../assets/img/声音.png" class="voice-img" />
           <span>播放</span>
         </div>
        </div>
      </div>
    </div>

    <div class="ub" style="padding:0 .8em">
            <div class="menu-line"></div>
    </div>
</div>

<div class="btn-block2">
    <span @click="goto_play_apply2()">上传录音</span>
    <span @click="goto_play_apply3()">上传图片</span>
    <span @click="goto_play_apply4()">选择标签</span>
    <span @click="goto_play_apply5()">修改签名</span>
</div>

</div>
   
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      "check":'',
      "info":{
        "uid":"",
        "photo":"",
        "nick":"",
        "sex":"",
        "age_range":"",
        "wx":"",
        "tel":"",
        "loc":"",
        "sign_self":"",
        "loc_province":"",
        "loc_city":"",
        "loc_area":"",
        "exper":"",
      },
      "play_info":{}
    };
  },
  mounted() {
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo"]), //引入方法
     back() {
      this.$router.go(-1); //返回上一层
    },
    goto_play_apply2(){
       this.$router.push({ name: "play_apply2"});
    },
     goto_play_apply3(){
       this.$router.push({ name: "play_apply3"});
    },
     goto_play_apply4(){
       this.$router.push({ name: "play_apply4"});
    },
     goto_play_apply5(){
       this.$router.push({ name: "play_apply5"});
    },
    goto_play_dtl(uid){
       this.$router.push({ name: "play_dtl", "params": { "uid_to":uid} });
    },
     changeCheck(val){
        this.check = val;
         if(this.check==1){
          this.info.sex="女生"
        }
        if(this.check==2){
          this.info.sex="男生"
        }
        console.log(this.info.sex);
    },

    init_page() {
      var uid = this.$store.state.uid;
      var self = this;

      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.info.uid = u.uid;
          self.info.photo = u.photo;
          self.info.nick = u.nick;
          self.info.sex = u.sex;
          self.info.age_range = u.age_range;
          self.info.wx = u.wx;
          self.info.tel = u.tel;
          self.info.loc_province = u.loc_province;
          self.info.loc_city = u.loc_city;
          self.info.loc_area = u.loc_area;
          if(u.loc_province==""&&u.loc_city==""){
            self.info.loc=""
          }else{
            self.info.loc = u.loc_province+"，"+u.loc_city;
          }
           
        },
      });


      self.get({
        url: "/App/Get_Play_Data_One/?uid=" + self.info.uid,
        success: function (data) {
          console.log(JSON.stringify(data));
          data.tags=data.tags.split(',');
          self.play_info=data;
          console.log(JSON.stringify(self.play_info));
        },
      });


    },
    seve(){
      if(this.info.nick==""){
        this.$toast.center("昵称不能为空哦");
        return false;
      } 
       if(this.info.age==""){
        this.$toast.center("年龄不能为空哦");
        return false;
      } 
       if(this.info.wx==""){
        this.$toast.center("请前往个人中心绑定微信号");
        return false;
      } 
      if(this.info.tel==""){
        this.$toast.center("请前往个人中心绑定手机号");
        return false;
      } 
      if(this.info.loc==""){
        this.$toast.center("请前往个人中心完善位置信息");
        return false;
      } 
        if(this.info.exper==""){
        this.$toast.center("相关经验不能为空哦");
        return false;
      } 
     
     var uid = this.$store.state.uid;
     var data_send={
       "uid":uid,
       "photo":this.info.photo,
       "nick":this.info.nick,
        "sex":this.info.sex,
        "age_range":this.info.age_range,
        "wx":this.info.wx,
        "tel":this.info.tel,
        "loc_province":this.info.loc_province,
        "loc_city":this.info.loc_city,
        "loc_area":this.info.loc_area,
        "exper":this.info.exper,
        "sign_self":this.info.sign_self,
        "play_level":"普通"
     };
     var strsend = JSON.stringify(data_send);
     //console.log(JSON.stringify(data_send));
     var self = this;
      this.post({
          url: "/App/Save_User_Play",
          data: { "uid": uid, "data": strsend },
          success: function (serve_data) {
           if(serve_data.state=="-1"){
              self.$toast.center("你已申请过配玩儿啦~");
              self.$router.push({ "name": "play_apply2"});
            }
            else if(serve_data.state=="1"){
              self.$router.push({ "name": "play_apply2"});
            }
            else
            {
              self.$toast.center("申请失败，请退出重试~");
            }
          },
        });
     
    }
  },
};
</script>

<style scoped>
.main{
   position: absolute;
   background-color: #fff;
   width: 100%;
   bottom: 0;
   top:0;
 }
.top{
  padding: .5em .8em;
  border-bottom: 1em solid #f5f5f5;
}
.top .sp1{
  font-size: 1.05em;
  font-weight: bold;
  padding: .8em 0;
}
.top .sp2{
  font-size: .9em;
  line-height: 1.5em;
}
.info2{
  border-bottom: .5em solid #f5f5f5;
}
.info-item {
    padding: .8em 0.8em;
   background-color: #fff;
  }
   
  .input-verify {
    background-color: transparent;
    margin-left: 0.8em;
    border: 0;
    outline: 0;
    font-size: .85em;
    display: inline-block;
    width: 100%;
  }
  .key{
      width: 5em;
      font-size: .95em;
      font-weight: bold;
  }
  .btn-block{
    background-color: #fff;
    padding: .4em .8em 1.5em .8em;
  }
  .submit-btn {
  width: 100%;
  height: 2.3em;
  line-height: 2.3em;
  border-radius: 1.15em;
  background-color: #fc568c;
  margin-top: .5em;
  color: #fff0f4;
}
 .rad{
     border: 2px solid #c9cacd;
     width: 1.1em;
     height:1.1em;
     border-radius: 50%;
     background-color: #fff;
     margin-right: .5em;
 }
 .rad_img{
     width: 100%;
     height:100%;
     border-radius: 50%;
 }
 .info-photo{
  padding: 0.5em 0.8em;
 }
 .photo{
   border-radius: 50%;
   width: 5em;
   height: 5em;
 }
/*---------------------------------------*/ 
 .btn-block2{
    background-color: #fff;
    padding: .8em 0;
}
.btn-block2 span{
    font-size: .95em;
    display: inline-block;
    border: 1px solid #e92162;
    padding: .3em .5em;
    margin:.4em .4em;
    border-radius: .3em;
    color: #e92162;
}

.infoma {
  padding: 1.3em .8em;
  background-color: #FFF;
}
.infoma:hover{
  background-color: #f2f3f5;
}

.photo-black{
  width: 5em;
  height: 5em;
  margin-right: .5em;
  position: relative;
}
.photo-tag{
  position: absolute;
  background-color: #f3b4cf;
  font-size: .8em;
  border-radius: 1em;
  color: #fff;
  padding: .1em .2em;
  width: 3em;
  bottom: .5em;
  right: .2em;
}
.photo {
  width: 5em;
  height: 5em;
  border-radius: 50%;
  
}
.nick2 {
  font-weight: bold;
  font-size: 0.85em;
   margin-left: .3em;
}
.sex-img {
  width: 1.2em;
}
.tip {
  margin-right: 0.5em;
}
.tip .d1 {
  width: 0.5em;
  height: 0.5em;
  background-color: #5ea3ef;
  border-radius: 50%;
  margin-right: 0.2em;
}
.tip .sp2{
  font-size: 0.85em;
}
.tag{
  display: inline-block;
  padding: .2em .5em;
  border:1px solid #5ea3ef;
  border-radius: 1em;
  font-size: .8em;
  color: #5ea3ef;
  margin: .3em .3em;
}
.voice{
  background-color: #5ea3ef;
  margin-left:.3em;
  font-size: .8em;
  width: 6em;
  color: #fff;
  padding: .5em .5em;
  border-radius: 2em;
  margin-top: .5em;
}
.voice-img{
width: 1.5em;
height: 1.5em;
margin-left: .5em;
}
</style>